module.exports = __webpack_public_path__ + "a389f5394e5972e7d3a05f76c8761acf.jpg";